// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2OpHW","bigColWidth":"Table_bigColWidth__A9a_k","biggerColWidth":"Table_biggerColWidth__2Y678","row":"Table_row__1b1S9","col":"Table_col__1XaXa"};